// material-ui
import { useTheme } from '@mui/material/styles';
import {Box, useMediaQuery} from '@mui/material';

import LogoSection from '../LogoSection';
import MobileSection from './MobileSection';
import FullScreenSection from './FullScreenSection';
import ThemeModeLayout from '../../Customization/ThemeMode';
import useConfig from "../../../../hooks/useConfig";
import LAYOUT_CONST from "../../../../constant";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const HeaderSecondary = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { layout } = useConfig();

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    // mb: 0.5,
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>

                {layout === LAYOUT_CONST.VERTICAL_LAYOUT || (layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && matchDownMd) ?
                    (<Box sx={{ display: { xs: 'block', sm: 'none' }, flexGrow: 1 }}>
                        <LogoSection short />
                    </Box>)
                    :
                    null
                }
            </Box>




            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* full sceen toggler */}
            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <FullScreenSection />
            </Box>
            <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
                <ThemeModeLayout />
            </Box>
            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </>
    );
};

export default HeaderSecondary;
